/* eslint-disable react-hooks/exhaustive-deps */
import {Notification} from 'iconsax-react';
import {COLORS} from '../../../../assets/color';
import {useAdmin} from '../../../../app/hooks';
import {useEffect, useState} from 'react';
import {AdminServices} from '../../../../redux/services/admin/admin';

interface INotificationIcon {
  onClick: () => void;
}
const NotificationIcon = ({onClick}: INotificationIcon) => {
  const token = useAdmin().adminToken;
  const [count, setCount] = useState(0);
  // Get Messages
  useEffect(() => {
    getMessages();
  }, []);

  const getMessages = async () => {
    try {
      const response = await AdminServices.allMessages(token);
      // console.log('Reseponse', response);
      if (response.data.status === 'success') {
        const res = response.data?.data;
        setCount(res.unreadCount);
        // console.log('profile', profile);
      }
    } catch (error: any) {
      // axiosError(error.response);
      console.log(error);
    }
  };
  return (
    <div
      onClick={onClick}
      className='flex justify-center items-center flex-row cursor-pointer'
      style={{
        backgroundColor: '#FFFFFF',
        width: 32,
        height: 32,
        borderRadius: 15,
      }}>
      <div onClick={() => ''} className='relative'>
        <Notification size={20} color={COLORS.primary} variant='Bold' />
        {count === 0 ? (
          <div></div>
        ) : (
          <div
            style={{
              backgroundColor: 'red',
              width: 14,
              height: 14,
              position: 'absolute',
              top: -2,
              right: 0,
              borderRadius: 7,
            }}
            className='flex flex-row justify-center items-center'>
            <p className='text-[10px] text-white'>{count}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default NotificationIcon;
